import { DefaultButton, Spinner, SpinnerSize } from '@fluentui/react';
import { useContext, useEffect, useRef, useState } from 'react';
import { ThemeContext } from "@fluentui/react-theme-provider";
import Auth from '@/Auth/Auth';
import * as Style from './ActiveSavingPlansStyle';
import TableActiveSavingPlans from './TableActiveSavingPlans/TableActiveSavingPlans';
import UserService from '@/services/UserService';
import { useHistory } from "react-router-dom";
import React from 'react';
import { useDispatch } from "react-redux";
import { setActiveSavingsPlan, setSavingsPlanElementsStatus } from '@/store/auth/actions'
import { ITableSPlansActive } from './types/SavePlansTypes';
import SavingsPlanService from '@/services/SavingsPlanService';

const ActiveSavingPlans = ({data, loading, activePlan, error} : {data?: ITableSPlansActive[], loading: boolean, activePlan: any, error: any}) =>
{
    var columns =
    [
        "Planes de Cartera y Carteras Modelo Asociadas",
        "Fecha de Inicio",
        "Fecha de Validez",
        "Tipo de Plan",
        "Seleccionar",
        "Acciones"
    ];
    const theme = useContext(ThemeContext);
    const userId = Auth.getUserProfile().id;
    const [savingsPlans, setSavingsPlans] = useState<ITableSPlansActive[]>();
    const [saveActivePlan, setActivePlan] = useState();
    const [updatePlanName, setUpdatePlanName] = useState("");
    const [updatePlanId, setUpdatePlanId] = useState(-1);
    const firstTime = useRef<boolean>(false);
    const hasToRedirect = useRef<boolean>(false);
    const changeName = useRef<boolean>(false);
    let history = useHistory();
    const dispatch = useDispatch();

    useEffect(() =>
    {
        if(data !== undefined && savingsPlans === undefined)
        {
            setSavingsPlans(data);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    const notifyChangedActivePlan = async (activePlan: any) =>
    {
        await dispatch(setActiveSavingsPlan({ ...activePlan, sync: true }));
        await dispatch(setSavingsPlanElementsStatus(activePlan.id ?? activePlan.planId));
    }

    const savePlan = (e: any, hTR: boolean) =>
    {
        if(hTR === true)
        {
            firstTime.current = true;
            hasToRedirect.current = true;
            setActivePlan(e);
        }
        else
        {
            firstTime.current = true;
            hasToRedirect.current = false;
            setActivePlan(e);
        }
    }

    const updatePlan = (n: any, i: number) =>
    {
        changeName.current = true;
        setUpdatePlanName(n);
        setUpdatePlanId(i);
    }

    useEffect(() =>
    {
        if(changeName.current === true)
        {
            changeName.current = false;
            SavingsPlanService.updateSavingPlanName(updatePlanId, userId, updatePlanName).then(async (response: any) =>
            {
                if(response === true)
                {
                    var aux = Auth.getActivePlan();

                    if(aux.id === updatePlanId && updatePlanName !== aux.name)
                    {
                        var item: any =
                        {
                            planId: updatePlanId,
                            planName: updatePlanName,
                            userId: userId,
                            type: aux.type,
                            status: 4,
                            outdated: aux.outdated,
                            outdatedContract: aux.outdatedContract,
                            cancelled: aux.cancelled,
                            portfolio: aux.portfolio,
                            finametrixContract: aux.finametrixContract,
                            userSubscriptionId: aux.userSubscriptionId
                        };

                        Auth.setActivePlan(item);
                        notifyChangedActivePlan(item);
                    }

                    var auxData: ITableSPlansActive[] = [];

                    if(savingsPlans !== undefined)
                    {
                        for (var i = 0; i < savingsPlans?.length; i++)
                        {
                            if(savingsPlans[i].id === updatePlanId)
                            {
                                savingsPlans[i].planName = updatePlanName;
                                auxData.push(savingsPlans[i]);
                            }
                            else
                            {
                                auxData.push(savingsPlans[i]);
                            }
                        }

                        setSavingsPlans(auxData);
                    }
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updatePlanId, updatePlanName, userId, savingsPlans]);

    useEffect(() =>
    {
        if(saveActivePlan !== undefined && (activePlan.id ?? activePlan.planId) !== saveActivePlan)
        {
            UserService.selectActivePlan(userId, saveActivePlan).then((response: any) =>
            {
                if(response === true)
                {
                    var activeSavingsPlan = savingsPlans?.find((sP: ITableSPlansActive) => sP.id === saveActivePlan);
                    if(activeSavingsPlan !== undefined)
                    {
                        Auth.setActivePlan(activeSavingsPlan);
                        notifyChangedActivePlan(activeSavingsPlan);
                    }
                    
                    if(hasToRedirect.current === true)
                    {
                        hasToRedirect.current = false;
                        history.push("/portfolio");
                    }
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [saveActivePlan, activePlan]);

    if(error.message)
    {
        return (<div>Error: {// @ts-ignore
            error.message}</div>)
    }
    return(
        <React.Fragment>
            <React.Fragment>
                <Style.Wrapper>
                    <div className="ms-Grid-row" style={{paddingTop: "1em"}}>
                        <div className="ms-Grid-col ms-sm12 ms-md8" style={{paddingTop: "2em"}}>
                            <Style.TitleContainer> 
                                <h3>
                                    Mis planes de cartera activos
                                </h3>
                            </Style.TitleContainer>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-md4 text-right">
                            <DefaultButton className="button tiny-primary-button" onClick={() => history.push("/savingsPlans/new")}>
                                Nuevo plan de cartera
                            </DefaultButton>
                        </div>
                    </div>
                    <Style.MainCont>
                        <Style.TableCont>
                            <Style.SubTitle theme={theme}>Planes de Cartera ({savingsPlans?.length}) y Carteras Modelo</Style.SubTitle>
                            <Style.TableContainer theme={theme}>
                                {loading === true && (<Spinner size={SpinnerSize.large} />)}
                                {loading === false &&
                                (
                                    <TableActiveSavingPlans
                                        theme={theme}
                                        columnTitles={columns}
                                        onlyShowing={4}
                                        rowData={savingsPlans as ITableSPlansActive[]}
                                        userId={userId}
                                        activePlan={activePlan}
                                        onClick={(ev: any, item: any, hTR: any) =>
                                        {
                                            savePlan(item, hTR);
                                        }}
                                        onSubmit={(item: any, id: number) =>
                                        {
                                            updatePlan(item, id);
                                        }}
                                    />
                                )}
                            </Style.TableContainer>
                        </Style.TableCont>
                    </Style.MainCont>
                </Style.Wrapper>
            </React.Fragment>
        </React.Fragment>
    );
}

export default ActiveSavingPlans;